import type { WebViewerInstance } from "@pdftron/webviewer"
import { resolveViewerPanes } from "./viewerPanes"

// The keyboard-shortcuts panel (REQ-359) is docked across the bottom of the viewer, ON TOP of the
// document area — Apryse has no bottom-panel location, the same gap `middlePanel.ts` works around for
// the split-screen sidebar. So while it is open it covers the lowest ~190px of the drawing: objects
// under it cannot be clicked, right-clicked or selected, which is exactly what it looked like from
// the outside ("I can't interact with the objects on the PDF").
//
// The fix is to give the SCROLLER that much extra room at the end, so anything the panel covers can
// be scrolled out from under it. `padding-bottom` is the coordinate-safe way to do that: it extends
// the scrollable range without moving any page, so every page-space → client-space conversion
// (AnnotationService.getClientRectFromBackendRect, the furniture labels, the draft rect) keeps
// working untouched. `padding-top` or a transform would shift the pages and break all of them.
//
// Apryse replaces the scroll elements when it re-mounts the document area, so callers must re-apply
// this on every `layoutEpoch` bump — and it fans out across BOTH panes, since split screen runs two.
export const applyBottomDockInset = (instance: WebViewerInstance | null, inset: number): void => {
	resolveViewerPanes(instance).forEach(({ scrollEl }) => {
		// "" rather than "0px": hand the element back to whatever Apryse's own stylesheet says.
		scrollEl.style.paddingBottom = inset > 0 ? `${inset}px` : ""
	})
}
